export default {
  geolocation: {
    lat: '-12.046153',
    lng: '-77.043555',
    label: '15079 Lima',
  },
  price_rules: {
    grouping: ',',
    decimal: '.',
  },
}
